module.exports = __webpack_public_path__ + "img/benfica.9f91b714.png";